import BottomMenu from "./BottomMenu";
import React from "react";
import {Outlet} from "react-router-dom";
import NotificationHandler from "./NotificationHandler";

interface IBaseLayoutProps {

}

const BaseLayout: React.FC<IBaseLayoutProps> = () => {
    return (
    <>
                <Outlet />
                <BottomMenu />
                <NotificationHandler />
    </>
    );
};

export default BaseLayout;
